import React from 'react';
import loadable from '@loadable/component';

import myReviewsQuery from './me.graphql';

import { Props as MyProfileProps } from './views/my-profile';

export const MyProfile = loadable(() =>
  import(/* webpackChunkName: "profile" */ './views/my-profile')
);

// Fixes loadable type errors `Property 'graphQL' does not exist on type`

const MyProfilePage = (props: MyProfileProps) => {
  return <MyProfile {...props} />;
};

type Variables = {
  offset: string | number;
  section: string;
};

MyProfilePage.variables = ({ offset = 0, section }: Variables) => {
  return {
    offset: typeof offset === 'string' ? parseInt(offset, 10) : offset,
    section,
  };
};

MyProfilePage.group = ({
  name,
  variables,
}: {
  name: String;
  variables: Variables;
}) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => key === 'offset')
        .filter(key => variables[key])
        .map(key => variables[key])
    : [];

  return `${name}_${groupVariables.join('_')}`;
};

MyProfilePage.graphQL = myReviewsQuery;

export default MyProfilePage;
